import React from "react";
import './../styles/legal-pages.css';

const LegalNotice = () => {
  return (
    <div className="legal-page-container">
      <h1>Conditions Générales d’Utilisation et de Vente (CGU/CGV)</h1>

      <section>
        <h2>Article 1 – Identification du site</h2>
        <p>
          L’adresse de notre site est : <a href="https://gioco-mortale.com">https://gioco-mortale.com</a>. 
          Ce site propose des jeux de murder party en ligne à télécharger ou à consulter directement via notre plateforme.
        </p>
      </section>

      <section>
        <h2>Article 2 – Nature du service</h2>
        <p>
          Le site permet aux utilisateurs d’acheter et d’accéder à des jeux de murder party sous forme de fichiers numériques ou en consultation en ligne. 
          Ces jeux sont destinés à un usage personnel et ludique.
        </p>
      </section>

      <section>
        <h2>Article 3 – Conditions d’utilisation du site</h2>
        <p>En utilisant ce site, les utilisateurs s’engagent à :</p>
        <ul>
          <li>Utiliser les jeux et contenus uniquement à des fins personnelles et privées.</li>
          <li>Ne pas redistribuer, partager, revendre ou modifier les fichiers achetés sans autorisation expresse de Gioco Mortale.</li>
          <li>Respecter la propriété intellectuelle des créations mises à disposition.</li>
          <li>Ne pas utiliser les jeux dans un cadre commercial sans accord préalable.</li>
          <li>Ne pas utiliser le site à des fins frauduleuses, abusives ou illégales.</li>
        </ul>
        <p>
          Tout manquement à ces engagements pourra entraîner la suspension du compte de l’utilisateur ou des poursuites légales.
        </p>
      </section>

      <section>
        <h2>Article 4 – Commandes et paiements</h2>
        <p>
          Les jeux sont disponibles à l’achat via notre site internet. Le paiement s’effectue en ligne par les moyens sécurisés disponibles. 
          Une fois le paiement confirmé, le jeu est accessible au téléchargement ou à la consultation en ligne.
        </p>
        <p>
          Aucun remboursement n’est possible après l’achat, sauf en cas de problème technique avéré rendant le fichier inutilisable.
        </p>
      </section>

      <section>
        <h2>Article 5 – Responsabilités</h2>
        <p>
          Le site Gioco Mortale met tout en œuvre pour garantir la qualité et la disponibilité des jeux. Toutefois, il ne peut être tenu responsable en cas de :
        </p>
        <ul>
          <li>Problème technique ou interruption de service.</li>
          <li>Erreurs dans les contenus des jeux.</li>
          <li>Mauvaise utilisation des fichiers par l’utilisateur.</li>
          <li>Incompatibilités techniques avec certains appareils.</li>
        </ul>
      </section>

      <section>
        <h2>Article 6 – Gestion des cookies</h2>
        <p>Le site utilise des cookies pour améliorer l’expérience utilisateur :</p>
        <ul>
          <li>Cookies de connexion : permettent de sauvegarder vos préférences et expirent à la fermeture du navigateur.</li>
          <li>Cookies analytiques : permettent d’améliorer le service en analysant l’utilisation du site.</li>
          <li>Cookies tiers : certains contenus intégrés peuvent collecter des données via des cookies.</li>
        </ul>
      </section>

      <section>
        <h2>Article 7 – Traitement des données personnelles</h2>
        <p>Les données personnelles collectées sont traitées conformément à la réglementation en vigueur. Cela inclut :</p>
        <ul>
          <li>Collecte des informations nécessaires à la gestion des commandes et des comptes utilisateurs.</li>
          <li>Conservation des données aussi longtemps que nécessaire pour l’exécution des services.</li>
          <li>Droit d’accès, de rectification et de suppression des données sur simple demande à l’adresse <a href="mailto:contact@gioco-mortale.com">contact@gioco-mortale.com</a>.</li>
        </ul>
      </section>

      <section>
        <h2>Article 8 – Litiges et juridiction</h2>
        <p>
          En cas de litige, les parties s’engagent à rechercher une solution amiable avant toute action en justice.
        </p>
        <p>
          Les présentes CGU/CGV sont soumises au droit français. Tout litige relévant de leur interprétation ou de leur exécution sera soumis aux tribunaux compétents.
        </p>
      </section>

      <p>Date de mise à jour : 07/03/2025</p>
    </div>
  );
};

export default LegalNotice;
